module.exports = __webpack_public_path__ + "img/reaction15.a38b0ff1.png";